import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { PROFILE_LEAD_ONLINE_LEADS_FLAG } from '@/hooks/useProfileLeadQueue';

export const CONSUMER_ONLINE_LEADS_FLAG = 'consumer_funnel_master';

/**
 * Online Leads is one inbox for every online lead source: website messages
 * from loan officer pages (profile_lead_online_leads_v1) and, once launched,
 * the rate funnel (consumer_funnel_master). It opens as soon as either source
 * resolves on, and stays closed until both resolve.
 */
export function useOnlineLeadsGate() {
  const consumer = useFeatureFlag(CONSUMER_ONLINE_LEADS_FLAG);
  const website = useFeatureFlag(PROFILE_LEAD_ONLINE_LEADS_FLAG);
  const consumerEnabled = !consumer.loading && consumer.enabled;
  const websiteEnabled = !website.loading && website.enabled;
  const enabled = consumerEnabled || websiteEnabled;
  return {
    loading: !enabled && (consumer.loading || website.loading),
    enabled,
    consumerEnabled,
    websiteEnabled
  };
}
